import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import _ from 'lodash';
import User from 'main/stores/users/User';
import {AnnouncementComment, AnnouncementReaction} from 'main/stores/announcements';
import {filestackUploadPolicy} from 'shared/core';
import {AttachedDocument} from 'main/stores/documents';

class Announcement extends DomainObject {
  id;
  name;
  description;
  lexicalState;
  pinnedAt;
  publishedAt;
  publishedByUser;
  employeeId;
  reactions;
  comments;
  image;
  visibleToCount;

  _relations = {
    publishedByUser: User,
    _dates: ['publishedAt', 'pinnedAt'],
    comments: [AnnouncementComment],
    reactions: [AnnouncementReaction],
    image: AttachedDocument
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      description: observable,
      lexicalState: observable,
      pinnedAt: observable,
      publishedAt: observable,
      publishedByUser: observable,
      employeeId: observable,
      reactions: observable,
      comments: observable,
      image: observable,
      visibleToCount: observable,
      groupedReactions: computed,
      imageUrl: computed,
      pinned: computed
    });

    this.merge(other);
  }

  get pinned() {
    return !!this.pinnedAt;
  }

  get groupedReactions() {
    return _(this.reactions)
      .groupBy(r => r.emojiKey)
      .map(value => (
        {
          emoji: value[0].emoji,
          emojiKey: value[0].emojiKey,
          reactions: value
        }
      ))
      .sortBy(value => value.emojiKey)
      .value();
  }

  get imageUrl() {
    if (!this.image) {
      return '';
    }

    return _.get(this.image, 'links.url.href') || `${this.image.label}?policy=${filestackUploadPolicy.policy}&signature=${filestackUploadPolicy.signature}`;
  }
}

export default Announcement;
